import { forEach } from 'lodash'
// import { dbfs, rtdb } from '@/plugins/firebase'
import { db, rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ], // move the dbfs eval to here
  methods: {
    _dbSave (target, paths, value) {
      return new Promise((resolve, reject) => {
        if (!target) {
          console.error('_dbSave: No target database was defined')
          return reject(new Error('_dbSave: No target database was defined'))
        }

        if (!paths) {
          console.error('_dbSave: No paths were supplied')
          return reject(new Error('_dbSave: No paths were supplied'))
        }
        if (!Array.isArray(paths)) { paths = [paths] }

        var updates = {}

        var rtdbSave = () => {
          forEach(paths, path => {
            updates[path] = value
          })

          rtdb.ref().update(updates, error => {
            if (!error) {
              resolve()
            } else {
              reject(error)
              console.error('_dbSave: ', error)
            }
          })
        }

        var dbSave = () => {
          var batch = db.batch()
        
          forEach(paths, path => {
            let dbfsRef = this._dbfsEvalPath(path)
            let write = {}
            write[dbfsRef.key] = value
            write = this._dotToObject(write)
            // batch.update(dbfs.doc(dbfsRef.path), write)
            batch.set(db.doc(dbfsRef.path), write, { merge: true })
          })
        
          batch.commit()
            .then(() => {
              resolve()
            })
            .catch(error => {
              reject(error)
              console.error('_dbSave: ', error)
            })
        }
        value = this._removeUndefined(value)
        switch (target) {
          case 'db': dbSave()
            break
          case 'rtdb': rtdbSave()
            break
        }
      })
    }
  }
}
